<template>
  <div class="modern-admin">
    <header-component />

    <div class="back-btn-container">
      <button class="back-btn" @click="$router.push('/adminpanel')">
        العودة للوحة التحكم
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
      </button>
    </div>

    <!-- Notification Section -->
    <div v-if="notification.message" class="notification-box">
      <div :class="['notification', notification.type]">
        {{ notification.message }}
      </div>
    </div>

    <div class="admin-container" dir="rtl">
      <div class="admin-header">
        <h1 class="page-title">إدارة الحجوزات</h1>
        <p class="page-subtitle">سفارة معرفة مكتبة الإسكندرية - جامعة العلمين الدولية</p>
      </div>

      <div v-if="isLoading" class="loading-container">
        <div class="loading-spinner"></div>
        <p>جاري التحميل...</p>
      </div>

      <!-- Content -->
      <div v-else>
        <!-- Registrations Management Section -->
        <div class="registrations-section">
          <div class="section-header">
            <h3 class="section-title">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg>
              جدول الحجوزات المسجلة
            </h3>
            
            <!-- Month Navigation -->
            <div class="month-navigation">
              <button @click="previousMonth" :disabled="!hasPreviousMonth" class="pagination-button">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="9 18 15 12 9 6"></polyline> 
                </svg>
              </button>
              
              <h4 class="current-month">{{ currentMonthName }} {{ currentYear }}</h4>
              
              <button @click="nextMonth" :disabled="!hasNextMonth" class="pagination-button">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="15 18 9 12 15 6"></polyline> 
                </svg>
              </button>
              
              <button @click="goToCurrentMonth" class="today-btn">
                اليوم
              </button>

              <!-- Export Button -->
              <button @click="openExportModal" class="export-btn">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                  <polyline points="7 10 12 15 17 10"></polyline>
                  <line x1="12" y1="15" x2="12" y2="3"></line>
                </svg>
                تحميل البيانات
              </button>
            </div>
          </div>

          <!-- Filters -->
          <div class="filters">
            <div class="filter-group">
              <label for="filter-day" class="filter-label">اليوم</label>
              <select v-model="filters.day" id="filter-day" class="filter-input">
                <option value="">كل الأيام</option>
                <option v-for="day in days" :key="day" :value="day">{{ day }}</option>
              </select>
            </div>
            
            <div class="filter-group">
              <label for="filter-date" class="filter-label">التاريخ</label>
              <input
                v-model="filters.date"
                type="date"
                id="filter-date"
                class="filter-input"
              />
            </div>

            <div class="filter-group">
            <label for="filter-time" class="filter-label">الوقت</label>
            <input
              v-model="filters.time"
              type="time"
              id="filter-time"
              class="filter-input"
            />
          </div>
            
            <div class="filter-group">
              <label class="filter-label">الرقم الجامعي:</label>
              <input v-model="filters.student_id" type="text" class="filter-input" placeholder="ابحث بالرقم الجامعي">
            </div>

            <div class="filter-group">
              <label class="filter-label">رقم الجهاز:</label>
              <input v-model="filters.device" type="text" class="filter-input" placeholder="ابحث برقم الجهاز">
            </div>
            
            <button @click="resetFilters" class="reset-btn">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="1 4 1 10 7 10"></polyline>
                <polyline points="23 20 23 14 17 14"></polyline>
                <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"></path>
              </svg>
              إعادة تعيين
            </button>
          </div>

          <!-- Bulk Actions -->
          <div class="bulk-actions" v-if="selectedRegistrations.length > 0">
            <button @click="toggleSelectAllMonthRegistrations" class="select-all-btn">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="9 11 12 14 23 3"></polyline>
                <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
              </svg>
              {{ selectedRegistrations.length === filteredRegistrations.length && filteredRegistrations.length > 0 ? 'إلغاء التحديد' : 'تحديد الكل' }}
            </button>
            <button @click="openBulkDeleteModal" class="delete-btn">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="3 6 5 6 21 6"></polyline>
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                <line x1="10" y1="11" x2="10" y2="17"></line>
                <line x1="14" y1="11" x2="14" y2="17"></line>
              </svg>
              حذف المحدد ({{ selectedRegistrations.length }})
            </button>
          </div>

          <div v-for="group in groupedRegistrations" :key="group.date" class="date-group">
            <div class="date-header" @click="toggleDayExpansion(group.date)">
              <input 
                type="checkbox" 
                :checked="isAllRegistrationsSelectedForDate(group.date)"
                @click.stop="toggleSelectAllDateRegistrations(group.date)"
              />
              <h4>
                {{ group.dayName }}، {{ group.formattedDate }}
                <span class="registration-count">{{ group.registrations.length }} حجز</span>
              </h4>
              <span class="arrow-icon">{{ expandedDays.includes(group.date) ? '▼' : '◄' }}</span>
            </div>
            
            <!-- Group by slot time -->
            <div v-if="expandedDays.includes(group.date)">
              <div v-for="slotGroup in groupBySlot(group.registrations)" :key="slotGroup.key" class="slot-group">
                <div class="slot-header" @click="toggleSlotExpansion(slotGroup.key)">
                  <input 
                    type="checkbox" 
                    :checked="isAllRegistrationsSelectedForSlot(slotGroup.key)"
                    @click.stop="toggleSelectAllSlotRegistrations(slotGroup.key)"
                  />
                  <h5>
                    <span class="arrow-icon">{{ isSlotExpanded(slotGroup.key) ? '▼' : '◄' }}</span>
                    {{ formatTimeTo12H(slotGroup.startTime) }} - {{ formatTimeTo12H(slotGroup.endTime) }}
                    <span class="slot-registration-count">{{ slotGroup.registrations.length }} حجز</span>
                  </h5>
                </div>
    
                <table class="registrations-table" v-if="isSlotExpanded(slotGroup.key)">
                  <thead>
                    <tr>
                      <th class="select-col"></th>
                      <th class="device-col">رقم الجهاز</th>
                      <th class="student-col">الرقم الجامعي</th>
                      <th class="email-col">البريد الجامعي</th>
                      <th class="name-col">اسم الطالب</th>
                      <th class="faculty-col">المجال</th>
                      <th class="level-col">المستوي</th>
                      <th class="actions-col">الإجراءات</th>
                    </tr>
                  </thead>
                  
                  <tbody>
                    <tr v-for="registration in sortByDevice(slotGroup.registrations)" :key="registration._id" 
                        :class="{ 'selected-row': selectedRegistrations.includes(registration._id) }">
                      <td class="select-col">
                        <input 
                          type="checkbox" 
                          v-model="selectedRegistrations" 
                          :value="registration._id" 
                        />
                      </td>
                      <td>{{ registration.computer !== undefined && registration.computer !== null ? registration.computer.toString() : 'N/A' }}</td>
                      <td>{{ registration.student?.student_id || 'N/A' }}</td>
                      <td>{{ registration.student?.student_email || 'N/A' }}</td>
                      <td>{{ registration.student?.student_name || 'N/A' }}</td>
                      <td>{{ registration.student?.student_faculty || 'N/A' }}</td>
                      <td>{{ registration.student?.student_level || 'N/A' }}</td>
                      <td class="actions-col">
                        <button @click="startEditing(registration)" class="edit-btn">
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                          </svg>
                          تعديل
                        </button>
                        <button @click="openDeleteModal(registration._id)" class="delete-btn">
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="3 6 5 6 21 6"></polyline>
                            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                          </svg>
                          حذف
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          
          <div v-if="filteredRegistrations.length === 0" class="empty-row">
            <div class="empty-state">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
              </svg>
              <p>لا توجد حجوزات مسجلة</p>
              <button @click="goToCurrentMonth" class="today-btn">
                عرض حجوزات الشهر الحالي
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Export Data Modal -->
      <div v-if="isExportModalOpen" class="modal-overlay">
        <div class="modal-container">
          <div class="modal-header">
            <h3 class="modal-title">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="7 10 12 15 17 10"></polyline>
                <line x1="12" y1="15" x2="12" y2="3"></line>
              </svg>
              تحميل البيانات
            </h3>
            <button @click="closeExportModal" class="close-btn">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
          
          <div class="modal-body">
            <div class="form-group">
              <label>نوع التحميل</label>
              <select v-model="exportType" class="form-control">
                <option value="month">بيانات الشهر الحالي</option>
                <option value="day">بيانات يوم محدد</option>
                <option value="slot">بيانات فتره محدده</option>
              </select>
            </div>

            <div v-if="exportType === 'day'" class="form-group">
              <label>اختر اليوم</label>
              <select v-model="selectedExportDay" class="form-control">
                <option v-for="day in availableDays" :key="day.date" :value="day.date">
                  {{ day.dayName }}، {{ day.formattedDate }}
                </option>
              </select>
            </div>

            <div v-if="exportType === 'slot'" class="form-group">
              <label>اختر الحجز</label>
              <select v-model="selectedExportSlot" class="form-control">
                <option v-for="slot in availableSlotsForExport" :key="slot.key" :value="slot.key">
                  {{ slot.dayName }}، {{ slot.formattedDate }} - 
                  {{ formatTimeTo12H(slot.startTime) }} إلى {{ formatTimeTo12H(slot.endTime) }}
                </option>
              </select>
            </div>
          </div>
          
          <div class="modal-footer">
            <button @click="closeExportModal" class="cancel-btn">إلغاء</button>
            <button @click="confirmExport" class="export-confirm-btn">
              <span v-if="loading" class="spinner"></span>
              <span v-else>تحميل البيانات</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Delete Confirmation Modal -->
      <div v-if="isDeleteModalOpen" class="modal-overlay">
        <div class="modal-container">
          <div class="modal-header">
            <h3 class="modal-title">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
              </svg>
              تأكيد الحذف
            </h3>
            <button @click="closeDeleteModal" class="close-btn">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
          
          <div class="modal-body">
            <p>هل أنت متأكد من حذف هذه الحجز؟</p>
            <div class="registration-details">
              <p><strong>الطالب:</strong> {{ editRegistrationData.student?.student_name || 'N/A' }}</p>
              <p><strong>الرقم الجامعي:</strong> {{ editRegistrationData.student?.student_id || 'N/A' }}</p>
              <p><strong>التاريخ:</strong> {{ formatDate(editRegistrationData.slot?.date) }} ({{ getDayName(editRegistrationData.slot?.date) }})</p>
              <p><strong>الوقت:</strong> {{ formatTimeTo12H(editRegistrationData.slot?.start_time) }} - {{ formatTimeTo12H(editRegistrationData.slot?.end_time) }}</p>
              <p><strong>رقم الجهاز:</strong> {{ editRegistrationData.computer || 'N/A' }}</p>
            </div>
          </div>
          
          <div class="modal-footer">
            <button @click="closeDeleteModal" class="cancel-btn">إلغاء</button>
            <button @click="confirmDelete" class="delete-btn">
              <span v-if="loading" class="spinner"></span>
              <span v-else>نعم، احذف</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Bulk Delete Confirmation Modal -->
      <div v-if="isBulkDeleteModalOpen" class="modal-overlay">
        <div class="modal-container">
          <div class="modal-header">
            <h3 class="modal-title">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
              </svg>
              تأكيد الحذف
            </h3>
            <button @click="closeBulkDeleteModal" class="close-btn">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
          
          <div class="modal-body">
            <p>هل أنت متأكد من حذف الحجوزات المحددة؟</p>
            <p class="warning-text">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                <line x1="12" y1="9" x2="12" y2="13"></line>
                <line x1="12" y1="17" x2="12.01" y2="17"></line>
              </svg>
              سيتم حذف {{ selectedRegistrations.length }} حجوزات بشكل دائم
            </p>
          </div>
          
          <div class="modal-footer">
            <button @click="closeBulkDeleteModal" class="cancel-btn">إلغاء</button>
            <button @click="confirmBulkDelete" class="delete-btn">
              <span v-if="loading" class="spinner"></span>
              <span v-else>نعم، احذف الكل</span>
            </button>
          </div>
        </div>
      </div>

    <!-- Edit Registration Modal -->
      <div v-if="isEditModalOpen" class="modal-overlay">
        <div class="modal-container">
          <div class="modal-header">
            <h3 class="modal-title">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
              </svg>
              تعديل الحجز
            </h3>
            <button @click="closeEditModal" class="close-btn">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
          
          <div class="modal-body">
            <div class="form-group">
              <label>الرقم الجامعي</label>
              <input v-model="editRegistrationData.student.student_id" type="text" class="form-control" readonly disabled />
            </div>
            
            <div class="form-group">
              <label>اسم الطالب</label>
              <input v-model="editRegistrationData.student.student_name" type="text" class="form-control" readonly disabled />
            </div>
            
            <div class="form-group">
              <label>التاريخ والوقت</label>
              <input :value="`${formatDate(editRegistrationData.slot?.date)} - ${formatTimeTo12H(editRegistrationData.slot?.start_time)}`" 
                    type="text" class="form-control" readonly disabled />
            </div>

            <div class="edit-options">
              <label>ما الذي تريد تعديله؟</label>
              <div class="radio-group">
                <label>
                  <input type="radio" v-model="editOption" value="device" @change="updateAvailableDevices">
                  تغيير الجهاز فقط
                </label>
                <label>
                  <input type="radio" v-model="editOption" value="slot" @change="loadAvailableSlotsForEdit">
                  تغيير الحجز بالكامل
                </label>
              </div>
            </div>

            <div v-if="editOption === 'slot'" class="form-group">
              <label>اختر الحجز الجديد</label>
              <select v-model="editRegistrationData.slot_id" class="form-control" @change="updateAvailableDevices">
                <option :value="editRegistrationData.slot_id">اختر موعد الحجز الجديد</option>
                <option v-for="slot in availableSlotsForEdit" 
                        :key="slot._id" 
                        :value="slot._id"
                        :disabled="slot.registrations_count >= totalDevices">
                  {{ formatDate(slot.date) }} ({{ getDayName(slot.date) }}) - 
                  {{ formatTimeTo12H(slot.start_time) }} - {{ formatTimeTo12H(slot.end_time) }}
                  ({{ slot.registrations_count }}/{{ totalDevices }})
                </option>
              </select>
            </div>
            
            <div class="form-group">
              <label>رقم الجهاز</label>
              <select v-model="editRegistrationData.computer" class="form-control" required>
                <option value="">اختر جهاز</option>
                <option v-for="device in availableDevices" :key="device" :value="device">
                  {{ device }}
                </option>
                <option v-if="availableDevices.length === 0" value="" disabled>
                  لا توجد أجهزة متاحة في هذا الحجز
                </option>
              </select>
            </div>
          </div>
          
          <div class="modal-footer">
            <button @click="closeEditModal" class="cancel-btn">إلغاء</button>
            <button @click="saveEditedRegistration" class="save-btn">
              <span v-if="loading" class="spinner"></span>
              <span v-else>حفظ التغييرات</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Footer Component -->
    <footer-component />
  </div>
</template>

<script>
import axios from 'axios';
import HeaderComponent from '../../../public/global/headerComponent.vue';
import FooterComponent from '../../../public/global/footerComponent.vue';
import * as XLSX from 'xlsx';

export default {
  name: 'AdminRegistrations',
  components: { HeaderComponent, FooterComponent },
  data() {
    return {
      registrations: [],
      availableSlots: [],
      availableSlotsForEdit: [],
      expandedSlots: [],
      studentsMap: {},
      isLoading: false,
      editOption: 'device',
      filters: {
        date: '',
        day: '',
        time: '',
        student_id: '',
        student_name: '',
        device: ''
      },
      days: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
      months: [
        "يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو",
        "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"
      ],
      currentMonth: new Date().getMonth(),
      currentYear: new Date().getFullYear(),
      isDeleteModalOpen: false,
      isBulkDeleteModalOpen: false,
      isEditModalOpen: false,
      isExportModalOpen: false,
      registrationToDelete: null,
      editRegistrationData: {
        _id: '',
        student_id: '',
        slot_id: '',
        computer: '',
        student: {
          student_id: '',
          student_name: '',
          student_email: '',
          student_faculty: '',
          student_level: ''
        },
        slot: {
          date: '',
          start_time: '',
          end_time: ''
        }
      },
      selectedRegistrations: [],
      notification: {
        message: '',
        type: '',
      },
      loading: false,
      editingRegistrationId: null,
      expandedDays: [],
      totalDevices: 20,
      availableDevices: [],
      allDevices: Array.from({length: 20}, (_, i) => (i + 1).toString()),
      availableTimes: [],
      exportType: 'month',
      selectedExportDay: '',
      selectedExportSlot: ''
    };
  },
  computed: {
    currentMonthName() {
      return this.months[this.currentMonth];
    },
    hasPreviousMonth() {
      const now = new Date();
      const currentDate = new Date(this.currentYear, this.currentMonth, 1);
      return currentDate > new Date(now.getFullYear(), now.getMonth() - 3, 1);
    },
    hasNextMonth() {
      const now = new Date();
      const currentDate = new Date(this.currentYear, this.currentMonth, 1);
      return currentDate < new Date(now.getFullYear(), now.getMonth() + 12, 1);
    },
    filteredRegistrations() {
      return this.registrations.filter(registration => {
        const slot = registration.slot || {};
        const slotDate = new Date(slot.date);
        
        if (isNaN(slotDate.getTime())) return false;
        
        const matchesMonthYear = (
          slotDate.getMonth() === this.currentMonth &&
          slotDate.getFullYear() === this.currentYear
        );
        
        const matchesStudentId = !this.filters.student_id || 
          (registration.student?.student_id?.toString().includes(this.filters.student_id));
        
        const matchesStudentName = !this.filters.student_name || 
          (registration.student?.student_name?.toLowerCase().includes(this.filters.student_name.toLowerCase()));
        
        const matchesDevice = !this.filters.device || 
          (registration.computer !== undefined && 
          registration.computer !== null && 
          registration.computer.toString().includes(this.filters.device));
        
        const matchesDate = !this.filters.date || 
          (slot.date && this.formatDate(slot.date) === this.formatDate(this.filters.date));
        
        const matchesDay = !this.filters.day || 
          (slot.date && this.getDayName(slot.date) === this.filters.day);
        
        const matchesTime = !this.filters.time || 
          slot.start_time === this.filters.time;
        
        return matchesMonthYear && matchesStudentId && matchesStudentName && 
              matchesDevice && matchesDate && matchesDay && matchesTime;
      });
    },
    groupedRegistrations() {
      const groups = {};
      this.filteredRegistrations.forEach(registration => {
        const slot = registration.slot || {};
        const dateKey = slot.date;
        if (!groups[dateKey]) {
          groups[dateKey] = {
            date: slot.date,
            dayName: this.getDayName(slot.date),
            formattedDate: this.formatDate(slot.date),
            registrations: []
          };
        }
        groups[dateKey].registrations.push(registration);
      });
      return Object.values(groups).sort((a, b) => new Date(a.date) - new Date(b.date));
    },
    availableDays() {
      return this.groupedRegistrations.map(group => ({
        date: group.date,
        dayName: group.dayName,
        formattedDate: group.formattedDate
      }));
    },
    availableSlotsForExport() {
      const slots = [];
      this.groupedRegistrations.forEach(group => {
        const slotGroups = this.groupBySlot(group.registrations);
        slotGroups.forEach(slotGroup => {
          slots.push({
            key: slotGroup.key,
            date: group.date,
            dayName: group.dayName,
            formattedDate: group.formattedDate,
            startTime: slotGroup.startTime,
            endTime: slotGroup.endTime
          });
        });
      });
      return slots;
    }
  },
  watch: {
    filters: {
      handler(newFilters) {
        if (newFilters.day || newFilters.date) {
          this.updateAvailableTimes();
        }
      },
      deep: true
    }
  },
  methods: {
    groupBySlot(registrations) {
      const slotGroups = {};
      
      registrations.forEach(registration => {
        const slot = registration.slot || {};
        const slotKey = `${slot.date}-${slot.start_time}-${slot.end_time}`;
        
        if (!slotGroups[slotKey]) {
          slotGroups[slotKey] = {
            key: slotKey,
            startTime: slot.start_time,
            endTime: slot.end_time,
            registrations: []
          };
        }
        
        slotGroups[slotKey].registrations.push(registration);
      });
      
      return Object.values(slotGroups).sort((a, b) => {
        const timeA = a.startTime || "00:00";
        const timeB = b.startTime || "00:00";
        return timeA.localeCompare(timeB);
      });
    },
    
    toggleSlotExpansion(slotKey) {
      const index = this.expandedSlots.indexOf(slotKey);
      if (index === -1) {
        this.expandedSlots.push(slotKey);
      } else {
        this.expandedSlots.splice(index, 1);
      }
    },
    
    isSlotExpanded(slotKey) {
      return this.expandedSlots.includes(slotKey);
    },
    
    sortByDevice(registrations) {
      return [...registrations].sort((a, b) => {
        const deviceA = a.computer !== undefined && a.computer !== null ? a.computer.toString() : '';
        const deviceB = b.computer !== undefined && b.computer !== null ? b.computer.toString() : '';
        
        const numA = parseInt(deviceA, 10);
        const numB = parseInt(deviceB, 10);
        
        if (!isNaN(numA) && !isNaN(numB)) {
          return numA - numB;
        }
        
        return deviceA.localeCompare(deviceB, undefined, { numeric: true });
      });
    },
    
    isAllRegistrationsSelectedForSlot(slotKey) {
      const slotRegistrations = this.filteredRegistrations.filter(reg => {
        const slot = reg.slot || {};
        return `${slot.date}-${slot.start_time}-${slot.end_time}` === slotKey;
      });
      
      return slotRegistrations.length > 0 && 
             slotRegistrations.every(reg => this.selectedRegistrations.includes(reg._id));
    },
    
    toggleSelectAllSlotRegistrations(slotKey) {
      const slotRegistrationIds = this.filteredRegistrations
        .filter(reg => {
          const slot = reg.slot || {};
          return `${slot.date}-${slot.start_time}-${slot.end_time}` === slotKey;
        })
        .map(reg => reg._id);
      
      const allSelected = slotRegistrationIds.every(id => 
        this.selectedRegistrations.includes(id)
      );
      
      if (allSelected) {
        this.selectedRegistrations = this.selectedRegistrations.filter(
          id => !slotRegistrationIds.includes(id)
        );
      } else {
        const newSelections = [...new Set([...this.selectedRegistrations, ...slotRegistrationIds])];
        this.selectedRegistrations = newSelections;
      }
    },
    
    updateAvailableTimes() {
      const filtered = this.registrations.filter(registration => {
        const slot = registration.slot || {};
        const slotDate = new Date(slot.date);
        const matchesMonthYear = (
          slotDate.getMonth() === this.currentMonth &&
          slotDate.getFullYear() === this.currentYear
        );
        
        const matchesDay = !this.filters.day || 
          this.getDayName(slot.date) === this.filters.day;
        
        const matchesDate = !this.filters.date || 
          this.formatDate(slot.date) === this.formatDate(this.filters.date);
        
        return matchesMonthYear && matchesDay && matchesDate;
      });
      
      const times = new Set();
      filtered.forEach(registration => {
        const slot = registration.slot || {};
        if (slot.start_time) {
          times.add(slot.start_time);
        }
      });
      
      this.availableTimes = Array.from(times).sort();
    },
    
    exportToExcel(data, fileName) {
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "الحجوزات");
      XLSX.writeFile(workbook, `${fileName}.xlsx`);
    },
    
    openExportModal() {
      this.exportType = 'month';
      this.selectedExportDay = this.availableDays.length > 0 ? this.availableDays[0].date : '';
      this.selectedExportSlot = this.availableSlotsForExport.length > 0 ? this.availableSlotsForExport[0].key : '';
      this.isExportModalOpen = true;
    },
    
    closeExportModal() {
      this.isExportModalOpen = false;
    },
    
    confirmExport() {
      switch (this.exportType) {
        case 'month':
          this.exportCurrentMonth();
          break;
        case 'day':
          this.exportDay(this.selectedExportDay);
          break;
        case 'slot':
          this.exportSlot(this.selectedExportSlot);
          break;
      }
      this.closeExportModal();
    },
    
    exportCurrentMonth() {
      const data = this.filteredRegistrations.map(reg => ({
        'التاريخ': this.formatDate(reg.slot?.date),
        'اليوم': this.getDayName(reg.slot?.date),
        'الوقت': `${this.formatTimeTo12H(reg.slot?.start_time)} - ${this.formatTimeTo12H(reg.slot?.end_time)}`,
        'رقم الجهاز': reg.computer !== undefined && reg.computer !== null ? reg.computer.toString() : 'N/A',
        'الرقم الجامعي': reg.student?.student_id || 'N/A',
        'اسم الطالب': reg.student?.student_name || 'N/A',
        'البريد الجامعي': reg.student?.student_email || 'N/A',
        'المجال': reg.student?.student_faculty || 'N/A',
        'المستوي': reg.student?.student_level || 'N/A'
      }));
      
      const monthName = this.currentMonthName;
      const year = this.currentYear;
      this.exportToExcel(data, `حجوزات_${monthName}_${year}`);
      this.showNotification('تم تصدير بيانات الشهر بنجاح');
    },
    
    exportDay(date) {
      const dayRegistrations = this.filteredRegistrations.filter(
        reg => reg.slot?.date === date
      );
      
      const data = dayRegistrations.map(reg => ({
        'الوقت': `${this.formatTimeTo12H(reg.slot?.start_time)} - ${this.formatTimeTo12H(reg.slot?.end_time)}`,
        'رقم الجهاز': reg.computer !== undefined && reg.computer !== null ? reg.computer.toString() : 'N/A',
        'الرقم الجامعي': reg.student?.student_id || 'N/A',
        'اسم الطالب': reg.student?.student_name || 'N/A',
        'البريد الجامعي': reg.student?.student_email || 'N/A',
        'المجال': reg.student?.student_faculty || 'N/A',
        'المستوي': reg.student?.student_level || 'N/A'
      }));
      
      const dayName = this.getDayName(date);
      const formattedDate = this.formatDate(date);
      this.exportToExcel(data, `حجوزات_${dayName}_${formattedDate}`);
      this.showNotification('تم تصدير بيانات اليوم بنجاح');
    },
    
    exportSlot(slotKey) {
      const [date, startTime, endTime] = slotKey.split('-');
      const slotRegistrations = this.filteredRegistrations.filter(
        reg => reg.slot?.date === date && 
               reg.slot?.start_time === startTime && 
               reg.slot?.end_time === endTime
      );
      
      const data = slotRegistrations.map(reg => ({
        'رقم الجهاز': reg.computer !== undefined && reg.computer !== null ? reg.computer.toString() : 'N/A',
        'الرقم الجامعي': reg.student?.student_id || 'N/A',
        'اسم الطالب': reg.student?.student_name || 'N/A',
        'البريد الجامعي': reg.student?.student_email || 'N/A',
        'المجال': reg.student?.student_faculty || 'N/A',
        'المستوي': reg.student?.student_level || 'N/A'
      }));
      
      const dayName = this.getDayName(date);
      const formattedDate = this.formatDate(date);
      const formattedTime = `${this.formatTimeTo12H(startTime)}-${this.formatTimeTo12H(endTime)}`;
      this.exportToExcel(data, `حجوزات_${dayName}_${formattedDate}_${formattedTime}`);
      this.showNotification('تم تصدير بيانات الحجز بنجاح');
    },
    
    async loadAvailableSlotsForEdit() {
      try {
        const response = await axios.get("https://eok-aiu-backend.vercel.app/slots/list");
        this.availableSlotsForEdit = response.data
          .filter(slot => slot.is_available)
          .map(slot => {
            const registrations_count = this.registrations.filter(
              reg => reg.slot_id === slot._id
            ).length;
            return { ...slot, registrations_count };
          });
      } catch (error) {
        console.error("Error fetching available slots:", error);
        this.showNotification('فشل تحميل الحجوزات المتاحة', 'error');
      }
    },
    
   updateAvailableDevices() {
  if (this.editOption === 'device') {
    // For device-only change, show all available devices in current slot
    const slotRegistrations = this.registrations.filter(
      r => r.slot_id === this.editRegistrationData.slot_id && 
           r._id !== this.editRegistrationData._id
    );
    
    const takenDevices = new Set(
      slotRegistrations
        .map(r => r.computer ? r.computer.toString() : '')
        .filter(device => device !== '')
    );
    
    this.availableDevices = [];
    
    for (let i = 1; i <= this.totalDevices; i++) {
      const device = i.toString();
      if (!takenDevices.has(device)) {
        this.availableDevices.push(device);
      }
    }
    
    // Keep current device in the list even if it's taken (to allow keeping it)
    if (this.editRegistrationData.computer && 
        !this.availableDevices.includes(this.editRegistrationData.computer.toString())) {
      this.availableDevices.push(this.editRegistrationData.computer.toString());
    }
  } else {
    // For slot change, show all available devices in new slot
    if (!this.editRegistrationData.slot_id) return;
    
    const slotRegistrations = this.registrations.filter(
      r => r.slot_id === this.editRegistrationData.slot_id
    );
    
    const takenDevices = new Set(
      slotRegistrations
        .map(r => r.computer ? r.computer.toString() : '')
        .filter(device => device !== '')
    );
    
    this.availableDevices = [];
    
    for (let i = 1; i <= this.totalDevices; i++) {
      const device = i.toString();
      if (!takenDevices.has(device)) {
        this.availableDevices.push(device);
      }
    }
  }
  
  // Sort devices numerically
  this.availableDevices.sort((a, b) => {
    const numA = parseInt(a, 10);
    const numB = parseInt(b, 10);
    if (!isNaN(numA) && !isNaN(numB)) return numA - numB;
    return a.localeCompare(b, undefined, { numeric: true });
  });
},
    
    formatTimeTo12H(time) {
      if (!time) return '';
      const [hours, minutes] = time.split(':');
      let hours12 = parseInt(hours, 10) % 12 || 12;
      const ampm = parseInt(hours, 10) >= 12 ? 'م' : 'ص';
      return `${hours12}:${minutes} ${ampm}`;
    },

    getDayName(date) {
      if (!date) return '';
      return this.days[new Date(date).getDay()];
    },

    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();
      return `${day}/${month}/${year}`;
    },

    calculateDuration(startTime, endTime) {
      if (!startTime || !endTime) return 'غير متاح';
      const start = new Date(`1970-01-01T${startTime}:00`);
      const end = new Date(`1970-01-01T${endTime}:00`);
      if (isNaN(start) || isNaN(end)) return 'غير متاح';
      if (end <= start) return 'غير متاح';
      const diff = end - start;
      const hours = Math.floor(diff / 3600000);
      const minutes = Math.floor((diff % 3600000) / 60000);
      return `${hours} ساعة ${minutes} دقيقة`;
    },

    isSlotPassed(slot) {
      const now = new Date();
      const slotDate = new Date(slot.date);
      const slotStartTime = new Date(`${slot.date}T${slot.start_time}:00`);
      if (slotDate.toDateString() === now.toDateString()) {
        return now >= slotStartTime;
      }
      return slotDate < now;
    },

    previousMonth() {
      if (this.currentMonth === 0) {
        this.currentMonth = 11;
        this.currentYear--;
      } else {
        this.currentMonth--;
      }
      this.loadRegistrations();
    },

    nextMonth() {
      if (this.currentMonth === 11) {
        this.currentMonth = 0;
        this.currentYear++;
      } else {
        this.currentMonth++;
      }
      this.loadRegistrations();
    },

    goToCurrentMonth() {
      const now = new Date();
      this.currentMonth = now.getMonth();
      this.currentYear = now.getFullYear();
      this.loadRegistrations();
    },

    resetFilters() {
      this.filters = {
        date: '',
        day: '',
        time: '',
        student_id: '',
        student_name: '',
        device: ''
      };
    },

    showNotification(message, type = 'success') {
      this.notification.message = message;
      this.notification.type = type;
      setTimeout(() => {
        this.notification.message = '';
      }, 3000);
    },

    toggleSelectAllMonthRegistrations() {
      if (this.selectedRegistrations.length === this.filteredRegistrations.length && this.filteredRegistrations.length > 0) {
        this.selectedRegistrations = [];
      } else {
        this.selectedRegistrations = this.filteredRegistrations.map(reg => reg._id);
      }
    },

    isAllRegistrationsSelectedForDate(date) {
      const dateRegistrations = this.filteredRegistrations.filter(reg => reg.slot?.date === date);
      return dateRegistrations.length > 0 && dateRegistrations.every(reg => this.selectedRegistrations.includes(reg._id));
    },

    toggleSelectAllDateRegistrations(date) {
      const dateRegistrationIds = this.filteredRegistrations
        .filter(reg => reg.slot?.date === date)
        .map(reg => reg._id);
      
      const allSelected = dateRegistrationIds.every(id => 
        this.selectedRegistrations.includes(id)
      );
      
      if (allSelected) {
        this.selectedRegistrations = this.selectedRegistrations.filter(
          id => !dateRegistrationIds.includes(id)
        );
      } else {
        const newSelections = [...new Set([...this.selectedRegistrations, ...dateRegistrationIds])];
        this.selectedRegistrations = newSelections;
      }
    },

    toggleDayExpansion(date) {
      const index = this.expandedDays.indexOf(date);
      if (index === -1) {
        this.expandedDays.push(date);
      } else {
        this.expandedDays.splice(index, 1);
      }
    },

    openDeleteModal(registrationId) {
      const registration = this.registrations.find(r => r._id === registrationId);
      if (registration) {
        this.editRegistrationData = { ...registration };
        this.registrationToDelete = registrationId;
        this.isDeleteModalOpen = true;
      }
    },

    closeDeleteModal() {
      this.isDeleteModalOpen = false;
      this.registrationToDelete = null;
    },

    async confirmDelete() {
      if (!this.registrationToDelete) return;
      
      this.loading = true;
      try {
        await axios.delete(`https://eok-aiu-backend.vercel.app/registrations/${this.registrationToDelete}`);
        this.registrations = this.registrations.filter(reg => reg._id !== this.registrationToDelete);
        this.closeDeleteModal();
        this.showNotification('تم حذف الحجز بنجاح');
      } catch (error) {
        console.error('Error deleting registration:', error);
        this.showNotification('فشل حذف الحجز', 'error');
      } finally {
        this.loading = false;
      }
    },

    openBulkDeleteModal() {
      if (this.selectedRegistrations.length === 0) {
        this.showNotification('الرجاء تحديد حجوزات للحذف', 'error');
        return;
      }
      this.isBulkDeleteModalOpen = true;
    },

    closeBulkDeleteModal() {
      this.isBulkDeleteModalOpen = false;
    },

   async confirmBulkDelete() {
  if (this.selectedRegistrations.length === 0) return;
  
  this.loading = true;
  try {
    await axios.post('/registrations/bulk-delete', {
      registration_ids: this.selectedRegistrations
    });
    
    // Remove deleted registrations from local state
    this.registrations = this.registrations.filter(
      reg => !this.selectedRegistrations.includes(reg._id)
    );
    
    this.selectedRegistrations = [];
    this.closeBulkDeleteModal();
    this.showNotification(`تم حذف ${this.selectedRegistrations.length} حجوزات بنجاح`);
  } catch (error) {
    console.error('Error deleting bulk registrations:', error);
    this.showNotification('فشل حذف الحجوزات المحددة', 'error');
  } finally {
    this.loading = false;
  }
},

    async startEditing(registration) {
      this.editingRegistrationId = registration._id;
      this.editRegistrationData = { ...registration };
      await this.loadAvailableSlotsForEdit();
      this.updateAvailableDevices();
      this.isEditModalOpen = true;
    },

    closeEditModal() {
      this.isEditModalOpen = false;
      this.editingRegistrationId = null;
    },

    async saveEditedRegistration() {
  if (!this.editRegistrationData.computer) {
    this.showNotification('الرجاء اختيار رقم جهاز', 'error');
    return;
  }

  this.loading = true;
  try {
    const updateData = {
      computer: this.editRegistrationData.computer
    };
    
    // Only include slot_id if changing the slot
    if (this.editOption === 'slot') {
      updateData.slot_id = this.editRegistrationData.slot_id;
    }

    const response = await axios.put(
      `https://eok-aiu-backend.vercel.app/registrations/${this.editRegistrationData._id}`,
      updateData
    );

    const updatedRegistration = response.data;
    const slot = this.availableSlotsForEdit.find(s => s._id === updatedRegistration.slot_id) || 
                this.registrations.find(r => r._id === updatedRegistration._id)?.slot || {};
    
    updatedRegistration.slot = {
      date: slot.date,
      start_time: slot.start_time,
      end_time: slot.end_time
    };
    
    this.registrations = this.registrations.map(reg =>
      reg._id === updatedRegistration._id ? updatedRegistration : reg
    );

    this.closeEditModal();
    this.showNotification('تم تحديث الحجز بنجاح');
  } catch (error) {
    console.error('Error updating registration:', error);
    this.showNotification('فشل تحديث الحجز', 'error');
  } finally {
    this.loading = false;
  }
},

    async loadRegistrations() {
      this.isLoading = false;
      try {
        const registrationsResponse = await axios.get("https://eok-aiu-backend.vercel.app/registrations");
        this.registrations = registrationsResponse.data;

        this.registrations.sort((a, b) => {
          const dateA = new Date(a.slot?.date || a.slot_id?.date);
          const dateB = new Date(b.slot?.date || b.slot_id?.date);
          return dateA - dateB;
        });

        await this.loadStudentData();
        this.registrations = this.registrations.map((registration) => {
          const student = this.studentsMap[registration.student_id] || {};
          return {
            ...registration,
            slot: registration.slot || registration.slot_id,
            student,
          };
        });

        this.updateAvailableTimes();
      } catch (error) {
        console.error("Error loading registrations:", error);
        this.showNotification('فشل تحميل الحجوزات', 'error');
      } finally {
        this.isLoading = false;
      }
    },

    async loadStudentData() {
      try {
        const response = await axios.get("https://aiusu-backend.vercel.app/sdata");
        this.studentsMap = response.data.reduce((map, student) => {
          map[student.student_id] = student;
          return map;
        }, {});
      } catch (error) {
        console.error("Error loading student data:", error);
        this.showNotification('فشل تحميل بيانات الطلاب', 'error');
      }
    },

    async fetchAvailableSlots() {
      try {
        const response = await axios.get("https://eok-aiu-backend.vercel.app/slots/list");
        const slots = response.data.filter(slot => slot.is_available);

        slots.sort((a, b) => {
          const dateA = new Date(a.date);
          const dateB = new Date(b.date);

          if (dateA < dateB) return -1;
          if (dateA > dateB) return 1;

          const timeA = a.start_time || "00:00";
          const timeB = b.start_time || "00:00";
          if (timeA < timeB) return -1;
          if (timeA > timeB) return 1;

          return 0;
        });

        this.availableSlots = slots.map(slot => ({
          ...slot,
          day: this.getDayName(slot.date),
        }));
      } catch (error) {
        console.error("Error fetching available slots:", error);
        this.showNotification('فشل تحميل الحجوزات المتاحة', 'error');
      }
    }
  },
  async mounted() {
    await this.loadRegistrations();
    await this.fetchAvailableSlots();
  }
};
</script>

<style scoped>
/* Modern Admin Styles */
.modern-admin {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.6;
  color: #333;
  background-color: #f8f9fa;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.edit-options {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f5f5f5;
  border-radius: 8px;
}

.edit-options label {
  display: block;
  margin-bottom: 10px;
  font-weight: bold;
}

.radio-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.radio-group label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: normal;
  cursor: pointer;
}

.radio-group input[type="radio"] {
  margin: 0;
}


.export-confirm-btn {
  background-color: #4CAF50;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
}

.export-confirm-btn:hover {
  background-color: #45a049;
}

.export-buttons {
  display: flex;
  gap: 10px;
  margin-left: auto;
}

.export-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 8px 12px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.export-btn:hover {
  background-color: #45a049;
}


.slot-header {
  background-color: #f5f5f5;
  padding: 10px 15px;
  border-bottom: 1px solid #e0e0e0;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.slot-header h5 {
  margin: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1em;
  flex-grow: 1;
}

.arrow-icon {
  display: inline-block;
  width: 20px;
  text-align: center;
}

.slot-registration-count {
  background-color: #c92126;
  color: white;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.7em;
  margin-left: auto;
}

.admin-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1.5rem;
  flex: 1;
}

/* Loading State Styles */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px; /* Adjust height as needed */
}

.loading-spinner {
  border: 4px solid #f3f3f3; /* Light grey */
  border-top: 4px solid #0f106c; /* Blue */
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

/* Header Styles */
.admin-header {
  text-align: center;
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #e1e4e8;
}

.page-title {
  font-size: 2rem;
  color: #0f106c;
  margin-bottom: 0.5rem;
  font-weight: 700;
}

.page-subtitle {
  font-size: 1.1rem;
  color: #666;
}

/* Form Toggle Styles */
.form-toggle {
  display: flex;
  justify-content: center;
  gap: 0.75rem;
  margin-bottom: 2rem;
  flex-wrap: wrap;
}

.toggle-btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 8px;
  background-color: #f1f3f5;
  color: #555;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.toggle-btn.active {
  background-color: #0f106c;
  color: white;
}

.toggle-btn:hover:not(.active) {
  background-color: #e1e4e8;
}

/* Form Styles */
.admin-form {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  margin-bottom: 2rem;
}

.form-title {
  font-size: 1.25rem;
  color: #0f106c;
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.form-title svg {
  color: #0f106c;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.form-group {
  margin-bottom: 1rem;
}

.form-label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #555;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.form-label svg {
  color: #666;
}

.form-input {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s, box-shadow 0.3s;
}

.form-input:focus {
  outline: none;
  border-color: #0f106c;
  box-shadow: 0 0 0 3px rgba(15, 16, 108, 0.1);
}

.form-hint {
  margin-top: 0.5rem;
  font-size: 0.85rem;
  color: #666;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
}

.submit-btn {
  padding: 0.75rem 1.5rem;
  background-color: #0f106c;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.submit-btn:hover:not(:disabled) {
  background-color: #0c0d5a;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* Day Checkboxes */
.day-checkboxes {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.day-checkbox {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}

.day-checkbox input {
  display: none;
}

.day-circle {
  display: inline-block;
  width: 70px;
  padding: 0.5rem;
  border-radius: 8px;
  background-color: #f1f3f5;
  text-align: center;
  transition: all 0.3s ease;
  border: 1px solid #ddd;
}

.day-checkbox input:checked + .day-circle {
  background-color: #0f106c;
  color: white;
  border-color: #0f106c;
}

/* registrations Section */
.registrations-section {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.section-title {
  font-size: 1.25rem;
  color: #0f106c;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.section-title svg {
  color: #0f106c;
}

.month-navigation {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.current-month {
  margin: 0 -0.5rem;
  font-size: 1.3rem;
  color: #0f106c;
  font-weight: 600;
  min-width: 180px;
  text-align: center;
}

.pagination-buttons {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  justify-content: center;
}

.pagination-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.25rem;
  background-color: #c92126;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.95rem;
  font-weight: 500;
}

.pagination-button:hover:not(:disabled) {
  background-color: #0f106c;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.pagination-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
  opacity: 0.7;
}

.today-btn {
  padding: 0.5rem 1rem;
  background-color: #0f106c;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9rem;
}

.today-btn:hover {
  background-color: #0c0d5a;
}

/* Bulk Actions */
.bulk-actions {
  margin-bottom: 1rem;
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.select-all-btn {
  padding: 0.5rem 1rem;
  background-color: #0f106c;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
}

.select-all-btn:hover {
  background-color: #0c0d5a;
}

.delete-btn {
  padding: 0.5rem 1rem;
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
}

.delete-btn:hover {
  background-color: #c82333;
}

/* Filters */
.filters {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1.5rem;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 8px;
}

.filter-group {
  flex: 1;
  min-width: 150px;
}

.filter-label {
  display: block;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
  color: #555;
}

.filter-input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 0.9rem;
}

.reset-btn {
  padding: 0.5rem 1rem;
  background-color: #6c757d;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  align-self: flex-end;
}

.reset-btn:hover {
  background-color: #5a6268;
}

/* Grouped registrations Styles */
.date-group {
  margin-bottom: 2rem;
  border: 1px solid #e1e4e8;
  border-radius: 8px;
  overflow: hidden;
}

.date-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e1e4e8;
  cursor: pointer;
  gap: 0.5rem;
}

.date-header h4 {
  margin: 0;
  color: #0f106c;
  font-size: 1.1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-grow: 1;
}

.registration-count {
  background-color: #0f106c;
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.8rem;
}

.arrow-icon {
  margin-left: 0.5rem;
  font-size: 1rem;
  transition: transform 0.3s;
}

/* Table Styles */
.registrations-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
}

.registrations-table th {
  background-color: #f1f3f5;
  color: #333;
  padding: 0.75rem;
  text-align: right;
  font-weight: 500;
}

.registrations-table td {
  padding: 0.75rem;
  border-bottom: 1px solid #eee;
  text-align: right;
}

.registrations-table tr:last-child td {
  border-bottom: none;
}

.registrations-table tr:hover {
  background-color: #f8f9fa;
}

.selected-row {
  background-color: #e6f7ff !important;
}

/* Column Widths */
.select-col {
  width: 40px;
  text-align: center;
}

.time-col {
  min-width: 100px;
}

.duration-col {
  min-width: 120px;
}

.status-col {
  min-width: 120px;
}

.devices-col {
  min-width: 120px;
}

.actions-col {
  min-width: 150px;
}

/* Status Badges */
.status-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 500;
}

.status-badge.available {
  background-color: #d4edda;
  color: #155724;
}

.status-badge.booked {
  background-color: #f8d7da;
  color: #721c24;
}

.status-badge.expired {
  background-color: #fff3cd;
  color: #856404;
}

/* Device Status */
.available-text {
  color: #28a745;
  font-size: 0.8rem;
}

.full-text {
  color: #dc3545;
  font-size: 0.8rem;
}

/* Action Buttons */
.edit-btn, .delete-btn, .save-btn, .cancel-btn {
  padding: 0.5rem 0.75rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.8rem;
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  margin-left: 0.5rem;
}

.edit-btn {
  background-color: #ffc107;
  color: #212529;
}

.edit-btn:hover {
  background-color: #e0a800;
}

.delete-btn {
  background-color: #dc3545;
  color: white;
}

.delete-btn:hover {
  background-color: #c82333;
}

.save-btn {
  background-color: #c82333;
  color: white;
}

.save-btn:hover {
  background-color: #0f106c;
}

.cancel-btn {
  background-color: #6c757d;
  color: white;
}

.cancel-btn:hover {
  background-color: #5a6268;
}

/* Empty State */
.empty-row td {
  padding: 2rem;
  text-align: center;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  color: #666;
}

.empty-state svg {
  color: #999;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 1rem;
}

.modal-container {
  background-color: white;
  border-radius: 12px;
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
  animation: modalFadeIn 0.3s ease;
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 1px solid #eee;
}

.modal-title {
  margin: 0;
  font-size: 1.25rem;
  color: #0f106c;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.modal-title svg {
  color: #0f106c;
}

.close-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #666;
  padding: 0.5rem;
  border-radius: 50%;
  transition: background-color 0.3s;
}

.close-btn:hover {
  background-color: #f1f3f5;
}

.modal-body {
  padding: 1.5rem;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 1rem 1.5rem;
  border-top: 1px solid #eee;
}

.modal-btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
}

.modal-cancel-btn {
  background-color: #f1f3f5;
  color: #333;
}

.modal-cancel-btn:hover {
  background-color: #e1e4e8;
}

.modal-confirm-btn {
  background-color: #0f106c;
  color: white;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.modal-confirm-btn:hover:not(:disabled) {
  background-color: #0c0d5a;
}

.modal-delete-btn {
  background-color: #dc3545;
  color: white;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.modal-delete-btn:hover:not(:disabled) {
  background-color: #c82333;
}

.registration-details {
  background-color: #f8f9fa;
  padding: 1rem;
  border-radius: 8px;
  margin-top: 1rem;
}

.registration-details p {
  margin: 0.5rem 0;
}

.warning-text {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #dc3545;
  margin-top: 1rem;
  font-weight: 500;
}

.warning-text svg {
  color: #dc3545;
}

/* Spinner */
.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Notification */
.notification-box {
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 1100;
}

.notification {
  padding: 1rem 1.5rem;
  margin-bottom: 1rem;
  border-radius: 8px;
  color: white;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  animation: fadeIn 0.5s, fadeOut 0.5s 2.5s forwards;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.notification.success {
  background-color: #28a745;
}

.notification.error {
  background-color: #dc3545;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateX(100%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(100%);
  }
}

/* In-place editing styles */
.edit-input {
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  width: 100%;
  max-width: 120px;
}

.registration-info p {
  margin: 0.5rem 0;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 2rem;
}

/* Responsive Styles */
@media (max-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
  
.export-confirm-btn {
  background-color: #4CAF50;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
}

.export-confirm-btn:hover {
  background-color: #45a049;
}

/* Update modal styles */
.modal-body {
  padding: 20px;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
}

.form-control {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

/* Adjust slot header to accommodate the export button */
.slot-header {
  display: flex;
  align-items: center;
  padding: 8px 15px;
  background-color: #f5f7fa;
  border-radius: 4px;
  margin: 5px 0;
  cursor: pointer;
}

.date-header {
  display: flex;
  align-items: center;
  padding: 10px 15px;
  background-color: #e9ecef;
  border-radius: 4px;
  margin: 10px 0;
  cursor: pointer;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .filters {
    flex-direction: column;
  }
  
  .filter-group {
    margin-left: 0;
    margin-bottom: 10px;
    width: 100%;
  }
  
  .month-navigation {
    flex-wrap: wrap;
    gap: 10px;
  }
  
  .export-btn {
    margin-top: 10px;
    width: 100%;
  }
}

  .section-header {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .month-navigation {
    width: 100%;
    justify-content: space-between;
  }
  
  .filters {
    flex-direction: column;
    gap: 0.75rem;
  }
  
  .filter-group {
    min-width: 100%;
  }
  
  .registrations-table {
    font-size: 0.8rem;
  }
  
  .registrations-table th, 
  .registrations-table td {
    padding: 0.5rem;
  }
  
  .edit-btn, 
  .delete-btn {
    padding: 0.4rem 0.6rem;
    font-size: 0.75rem;
  }
}

@media (max-width: 480px) {
  .admin-container {
    padding: 1rem;
  }
  
  .page-title {
    font-size: 1.5rem;
  }
  
  .form-toggle {
    flex-direction: column;
    width: 100%;
  }
  
  .toggle-btn {
    width: 100%;
    justify-content: center;
  }
  
  .modal-container {
    max-height: 80vh;
  }
  
  .modal-footer {
    flex-direction: column;
  }
  
  .modal-btn {
    width: 100%;
    justify-content: center;
  }

  .edit-input {
    max-width: 80px;
  }
  
  .day-circle {
    width: 60px;
    padding: 0.4rem;
    font-size: 0.8rem;
  }

  .loading-container p {
  margin-top: 10px;
  font-size: 16px;
  color: #0f106c;
}
}

.back-btn-container {
  margin: 1.5rem 0 0 0;
  display: flex;
  justify-content: flex-end;
}

.back-btn {
  background-color: #0f106c;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.5rem 1.25rem;
  font-size: 1rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  transition: background 0.2s, box-shadow 0.2s;
}

.back-btn:hover {
  background-color: #23248c;
  box-shadow: 0 2px 8px rgba(15, 16, 108, 0.15);
}

</style>